import { render, staticRenderFns } from "./FabricComparisonPicker.vue?vue&type=template&id=ed445a34&scoped=true&"
import script from "./FabricComparisonPicker.vue?vue&type=script&lang=ts&"
export * from "./FabricComparisonPicker.vue?vue&type=script&lang=ts&"
import style0 from "./FabricComparisonPicker.vue?vue&type=style&index=0&id=ed445a34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed445a34",
  null
  
)

export default component.exports